module.exports = __webpack_public_path__ + "img/home_yy_icon.e9c7179.png";